import { Grid, Typography, Stack, Box } from '@mui/material';
import AnalyticsDashboardSelectOrg from '../../../assets/images/getting-started/dashboardinfo/analytics_dashboard_select_org.png';
import MainCard from "../../../Components/MainCard";
import ModifyUserAddOn from "../../../assets/images/getting-started/subscribinginfo/ModifyUserAddOn.png";
import SummaryView from "../../../assets/images/getting-started/dashboardinfo/SummaryView.png";
import PayablesView from "../../../assets/images/getting-started/dashboardinfo/PayablesView.png";
import ReceivablesView from "../../../assets/images/getting-started/dashboardinfo/ReceivablesView.png";
import DetailView from "../../../assets/images/getting-started/dashboardinfo/DetailView.png";

function DashboardInfo(){
    return (
        <MainCard>
        <Grid item xs={12}>
        <Stack spacing={2.5}>
            <Typography variant="h4">
                Dashboard Analytics
            </Typography>
            <Typography variant="body1">
                The Analytics Dashboard provides users with a comprehensive overview of several business performance metrics.
                Additionally, it provides users with an overview of receivables and payables segmented by various time periods.
            </Typography>
            <Typography variant="body1">
                All of this is achievable via a simple point and click user interface and all the information required is displayed
                in a visually appealing manner.
            </Typography>
            <Typography variant="body1">
                To navigate to the Analytics Dashboard simply click the Analytics Dashboard link from the home page once you have signed in.
            </Typography>
            <Typography variant="body1">
                If you have the Multi Organisation Plan you will need to select which Xero Organisation you would like
                to view dashboard analytics for.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img src={AnalyticsDashboardSelectOrg} alt="Select Xero Organisation" />
                </Box>
            </Typography>
            <Typography variant="h5">
                Summary
            </Typography>
            <Typography variant="body1">
                The Summary tab provides a high level overview of key financial performance indicators. In addition it provides a month to month trend for each metric. Depending on your business' circumstance you might have more or less financial metrics

                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={SummaryView} alt="Dashboard Summary View" />
                </Box>

            </Typography>
            <Typography variant="h5">
                Payables
            </Typography>
            <Typography variant="body1">
                The Payables tab provides insights into an organisation's aged payables. Payables are segmented into Over 90 days, 60-90 days and less then 60 days due.

                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={PayablesView} alt="Dashboard Payables View" />
                </Box>
            </Typography>
            <Typography variant="h5">
                Receivables
            </Typography>
            <Typography variant="body1">
                The Receivables tab provides insights into an organisation's aged receivables. Receivables are segmented into Over 90 days, 60-90 days and less then 60 days due.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={ReceivablesView} alt="Dashboard Receivables View" />
                </Box>
            </Typography>
            <Typography variant="h5">
                Payables/Receivables Detail View
            </Typography>
            <Typography variant="body1">
                To view a detailed view of an receivable or payable click on the eye icon under the Action column of the payable/receivable of interest.
                This will bring you to the detail view of the item which will look like below:

                You can also download the actual invoice by clicking the download icon on the top right.
                <Box
                    sx={{ position: 'relative', bottom: 0, right: 0 }}
                >
                    <img style={{width:'100%', height: '100%'}} src={DetailView} alt="Detail View" />
                </Box>
            </Typography>
        </Stack>
        </Grid>
            </MainCard>
    )

}

export default DashboardInfo;